import React from 'react';
import 'whatwg-fetch';

const databaseEntity = {
  contact: {
    message: 'contact',
    apiPost: '/api/contact/new/',
    apiShow: '/api/contact/show/',
  },
  customer: {
    message: 'client',
    apiPost: '/api/customer/new/',
    apiShow: '/api/customer/show/',
  },
  deal: {
    message: 'affaire',
    apiPost: '/api/deal/new/',
    apiShow: '/api/deal/show/',
    apiDelete: '/api/deal/',
    apiDuplicate: (id) => `/api/deal/${id}/duplicate`,
  },
  ticket: {
    message: 'ticket',
    apiPost: '/api/ticket/new/',
    apiShow: '/api/ticket/show/',
  },
  task: {
    message: 'tâche',
    apiPost: '/api/task/new/',
    apiShow: '/api/task/show/',
  },
  appointment: {
    message: 'rdv',
    apiPost: '/api/appointment/new/',
    apiShow: '/api/appointment/show/',
  },
  reminder: {
    message: 'rappel',
    apiPost: '/api/reminder/new/',
    apiShow: '/api/reminder/show/',
  },
  note: {
    message: 'note',
    apiPost: '/api/note/new/',
    apiShow: '/api/note/show/',
  },
  installation: {
    message: 'installation',
    apiShow: '/api/stepProduction/updateInstallation/',
  },
  dashboard: {
    message: 'dashboard',
    apiPost: '/api/dashboard/new/',
    apiDelete: '/api/dashboard/',
  },
  dashlet: {
    message: 'dashlet',
    apiPost: '/api/dashlet/new/',
    apiDelete: '/api/dashlet/',
  },
};

export function postEntity(authFetch, type, json) {
  let result = {
    wentFine: true,
    data: undefined,
    error: undefined,
  };

  let collaborative = databaseEntity[type];
  let queryURL = collaborative.apiPost;
  let data = 'data=' + encodeURIComponent(JSON.stringify(json));
  return authFetch(queryURL, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    method: 'POST',
    body: data,
  })
    .then((resp) => resp.json())
    .then(
      function (data) {
        if (!data.isValid) {
          result.wentFine = false;
        }
        if (data.error) {
          result.error = data.error;
        }

        return result;
      }.bind(this)
    )
    .catch(
      function (rror) {
        console.log(rror);
        result.wentFine = false;

        return result;
      }.bind(this)
    );
}

export function showEntity(authFetch, type, graphQL) {
  let result = {
    wentFine: true,
    data: undefined,
  };

  let collaborative = databaseEntity[type];
  let queryURL = collaborative.apiShow;
  let data = 'data=' + encodeURIComponent(graphQL);
  return authFetch(queryURL, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    method: 'POST',
    body: data,
  })
    .then((resp) => resp.json())
    .then((data) => {
      if (data['data'][type]) {
        result.data = data['data'];

        return result;
      } else {
        result.wentFine = false;

        return result;
      }
    })
    .catch((error) => {
      console.log(error);
      result.wentFine = false;

      return result;
    });
}

export function deleteEntity(authFetch, type, id) {
  let result = {
    wentFine: true,
    data: undefined,
  };

  let json = {};
  json[type] = {
    id: id,
  };

  let collaborative = databaseEntity[type];
  let queryURL = collaborative.apiDelete;
  queryURL += encodeURIComponent(JSON.stringify(json));
  return fetch(queryURL, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    method: 'DELETE',
  })
    .then((resp) => resp.json())
    .then((data) => {
      if (data['isValid']) {
        return result;
      } else {
        result.wentFine = false;
        result.data = data.error;

        return result;
      }
    })
    .catch(() => {
      result.wentFine = false;
      return result;
    });
}

export function duplicateEntity(authFetch, type, data) {
  let result = { wentFine: true, data: undefined };
  const { dealId, ...params } = data;

  let collaborative = databaseEntity[type];

  return authFetch(collaborative.apiDuplicate(dealId), {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
    method: 'POST',
  })
    .then((resp) => resp.json())
    .then((data) => {
      if (data['isValid']) {
        return result;
      } else {
        result.wentFine = false;
        result.data = data.error;

        return result;
      }
    })
    .catch(() => {
      result.wentFine = false;
      return result;
    });
}
